/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../../Labels.js';

/**
 * Animals theme with cute animal emojis (premium content).
 */
export class AnimalsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'animals',
            'Animals',
            allLabels.animals,
            { numPairs: 4, isPremium: true, hasMovement: false, ...options }
        );
    }
}
